export default __webpack_public_path__ + "static/media/SalesExecutive.5adf57c8.xlsx";